var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTodoProcess = function SvgTodoProcess(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.324 21.193",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 6168"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M10.716 21.043a10.44 10.44 0 0 1-9.356-5.838A10.406 10.406 0 0 1 13.311.556a.8.8 0 1 1-.4 1.551 8.805 8.805 0 0 0-10.113 12.4 8.97 8.97 0 0 0 8.156 4.937 8.807 8.807 0 0 0 8.282-11.012.8.8 0 1 1 1.551-.4 10.408 10.408 0 0 1-9.788 13.008z",
    "data-name": "Pfad 1312"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 6169"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M10.709 13.132a.8.8 0 0 1-.566-1.367l9.607-9.607a.8.8 0 0 1 1.132 1.132l-9.607 9.607a.8.8 0 0 1-.566.235Z",
    "data-name": "Pfad 1313"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 6170"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M10.709 13.132a.8.8 0 0 1-.566-.235l-3.4-3.4a.8.8 0 0 1 1.132-1.132l3.4 3.4a.8.8 0 0 1-.566 1.367Z",
    "data-name": "Pfad 1314"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTodoProcess);
export default ForwardRef;